import { render, staticRenderFns } from "./SeriesCard.vue?vue&type=template&id=2a887eba"
import script from "./SeriesCard.vue?vue&type=script&lang=js"
export * from "./SeriesCard.vue?vue&type=script&lang=js"
import style0 from "./SeriesCard.vue?vue&type=style&index=0&id=2a887eba&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports